import accessibility from '@gouvfr/dsfr/dist/artwork/pictograms/accessibility/accessibility.svg';
import earOff from '@gouvfr/dsfr/dist/artwork/pictograms/accessibility/ear-off.svg';
import eyeOff from '@gouvfr/dsfr/dist/artwork/pictograms/accessibility/eye-off.svg';
import mentalDisabilities from '@gouvfr/dsfr/dist/artwork/pictograms/accessibility/mental-disabilities.svg';
import wheelchair from '@gouvfr/dsfr/dist/artwork/pictograms/accessibility/wheelchair.svg';
import base from '@gouvfr/dsfr/dist/artwork/pictograms/buildings/base.svg';
import cityHall from '@gouvfr/dsfr/dist/artwork/pictograms/buildings/city-hall.svg';
import companie from '@gouvfr/dsfr/dist/artwork/pictograms/buildings/companie.svg';
import factory from '@gouvfr/dsfr/dist/artwork/pictograms/buildings/factory.svg';
import house from '@gouvfr/dsfr/dist/artwork/pictograms/buildings/house.svg';
import nuclearPlant from '@gouvfr/dsfr/dist/artwork/pictograms/buildings/nuclear-plant.svg';
import school from '@gouvfr/dsfr/dist/artwork/pictograms/buildings/school.svg';
import application from '@gouvfr/dsfr/dist/artwork/pictograms/digital/application.svg';
import avatar from '@gouvfr/dsfr/dist/artwork/pictograms/digital/avatar.svg';
import calendar from '@gouvfr/dsfr/dist/artwork/pictograms/digital/calendar.svg';
import coding from '@gouvfr/dsfr/dist/artwork/pictograms/digital/coding.svg';
import dataVisualization from '@gouvfr/dsfr/dist/artwork/pictograms/digital/data-visualization.svg';
import ecosystem from '@gouvfr/dsfr/dist/artwork/pictograms/digital/ecosystem.svg';
import inProgress from '@gouvfr/dsfr/dist/artwork/pictograms/digital/in-progress.svg';
import innovation from '@gouvfr/dsfr/dist/artwork/pictograms/digital/innovation.svg';
import internet from '@gouvfr/dsfr/dist/artwork/pictograms/digital/internet.svg';
import mailSend from '@gouvfr/dsfr/dist/artwork/pictograms/digital/mail-send.svg';
import search from '@gouvfr/dsfr/dist/artwork/pictograms/digital/search.svg';
import selfTraining from '@gouvfr/dsfr/dist/artwork/pictograms/digital/self-training.svg';
import smartphone from '@gouvfr/dsfr/dist/artwork/pictograms/digital/smartphone.svg';
import archive from '@gouvfr/dsfr/dist/artwork/pictograms/document/archive.svg';
import binders from '@gouvfr/dsfr/dist/artwork/pictograms/document/binders.svg';
import conclusion from '@gouvfr/dsfr/dist/artwork/pictograms/document/conclusion.svg';
import contract from '@gouvfr/dsfr/dist/artwork/pictograms/document/contract.svg';
import documentAdd from '@gouvfr/dsfr/dist/artwork/pictograms/document/document-add.svg';
import documentDownload from '@gouvfr/dsfr/dist/artwork/pictograms/document/document-download.svg';
import documentSearch from '@gouvfr/dsfr/dist/artwork/pictograms/document/document-search.svg';
import documentSignature from '@gouvfr/dsfr/dist/artwork/pictograms/document/document-signature.svg';
import document from '@gouvfr/dsfr/dist/artwork/pictograms/document/document.svg';
import drivingLicence from '@gouvfr/dsfr/dist/artwork/pictograms/document/driving-licence.svg';
import drivingLicenseNew from '@gouvfr/dsfr/dist/artwork/pictograms/document/driving-license-new.svg';
import internationalDrivingLicenseNew from '@gouvfr/dsfr/dist/artwork/pictograms/document/international-driving-license-new.svg';
import internationalDrivingLicense from '@gouvfr/dsfr/dist/artwork/pictograms/document/international-driving-license.svg';
import nationalIdentityCardPassport from '@gouvfr/dsfr/dist/artwork/pictograms/document/national-identity-card-passport.svg';
import nationalIdentityCard from '@gouvfr/dsfr/dist/artwork/pictograms/document/national-identity-card.svg';
import passport from '@gouvfr/dsfr/dist/artwork/pictograms/document/passport.svg';
import presseCard from '@gouvfr/dsfr/dist/artwork/pictograms/document/presse-card.svg';
import signDocument from '@gouvfr/dsfr/dist/artwork/pictograms/document/sign-document.svg';
import taxStamp from '@gouvfr/dsfr/dist/artwork/pictograms/document/tax-stamp.svg';
import vehicleRegistration from '@gouvfr/dsfr/dist/artwork/pictograms/document/vehicle-registration.svg';
import environment from '@gouvfr/dsfr/dist/artwork/pictograms/environment/environment.svg';
import food from '@gouvfr/dsfr/dist/artwork/pictograms/environment/food.svg';
import grocery from '@gouvfr/dsfr/dist/artwork/pictograms/environment/grocery.svg';
import humanCooperation from '@gouvfr/dsfr/dist/artwork/pictograms/environment/human-cooperation.svg';
import leaf from '@gouvfr/dsfr/dist/artwork/pictograms/environment/leaf.svg';
import moon from '@gouvfr/dsfr/dist/artwork/pictograms/environment/moon.svg';
import mountain from '@gouvfr/dsfr/dist/artwork/pictograms/environment/mountain.svg';
import sun from '@gouvfr/dsfr/dist/artwork/pictograms/environment/sun.svg';
import tree from '@gouvfr/dsfr/dist/artwork/pictograms/environment/tree.svg';
import doctor from '@gouvfr/dsfr/dist/artwork/pictograms/health/doctor.svg';
import health from '@gouvfr/dsfr/dist/artwork/pictograms/health/health.svg';
import hospital from '@gouvfr/dsfr/dist/artwork/pictograms/health/hospital.svg';
import medicalResearch from '@gouvfr/dsfr/dist/artwork/pictograms/health/medical-research.svg';
import vaccine from '@gouvfr/dsfr/dist/artwork/pictograms/health/vaccine.svg';
import virus from '@gouvfr/dsfr/dist/artwork/pictograms/health/virus.svg';
import armyTank from '@gouvfr/dsfr/dist/artwork/pictograms/institutions/army-tank.svg';
import astronaut from '@gouvfr/dsfr/dist/artwork/pictograms/institutions/astronaut.svg';
import firefighter from '@gouvfr/dsfr/dist/artwork/pictograms/institutions/firefighter.svg';
import gendarmerie from '@gouvfr/dsfr/dist/artwork/pictograms/institutions/gendarmerie.svg';
import justice from '@gouvfr/dsfr/dist/artwork/pictograms/institutions/justice.svg';
import money from '@gouvfr/dsfr/dist/artwork/pictograms/institutions/money.svg';
import navyAnchor from '@gouvfr/dsfr/dist/artwork/pictograms/institutions/navy-anchor.svg';
import navyBachi from '@gouvfr/dsfr/dist/artwork/pictograms/institutions/navy-bachi.svg';
import police from '@gouvfr/dsfr/dist/artwork/pictograms/institutions/police.svg';
import art from '@gouvfr/dsfr/dist/artwork/pictograms/leisure/art.svg';
import audio from '@gouvfr/dsfr/dist/artwork/pictograms/leisure/audio.svg';
import book from '@gouvfr/dsfr/dist/artwork/pictograms/leisure/book.svg';
import catalog from '@gouvfr/dsfr/dist/artwork/pictograms/leisure/catalog.svg';
import community from '@gouvfr/dsfr/dist/artwork/pictograms/leisure/community.svg';
import culture from '@gouvfr/dsfr/dist/artwork/pictograms/leisure/culture.svg';
import digitalArt from '@gouvfr/dsfr/dist/artwork/pictograms/leisure/digital-art.svg';
import paint from '@gouvfr/dsfr/dist/artwork/pictograms/leisure/paint.svg';
import pictures from '@gouvfr/dsfr/dist/artwork/pictograms/leisure/pictures.svg';
import podcast from '@gouvfr/dsfr/dist/artwork/pictograms/leisure/podcast.svg';
import videoGames from '@gouvfr/dsfr/dist/artwork/pictograms/leisure/video-games.svg';
import video from '@gouvfr/dsfr/dist/artwork/pictograms/leisure/video.svg';
import airport from '@gouvfr/dsfr/dist/artwork/pictograms/map/airport.svg';
import backpack from '@gouvfr/dsfr/dist/artwork/pictograms/map/backpack.svg';
import compass from '@gouvfr/dsfr/dist/artwork/pictograms/map/compass.svg';
import locationFrance from '@gouvfr/dsfr/dist/artwork/pictograms/map/location-france.svg';
import locationOverseasFrance from '@gouvfr/dsfr/dist/artwork/pictograms/map/location-overseas-france.svg';
import luggage from '@gouvfr/dsfr/dist/artwork/pictograms/map/luggage.svg';
import mapPin from '@gouvfr/dsfr/dist/artwork/pictograms/map/map-pin.svg';
import map from '@gouvfr/dsfr/dist/artwork/pictograms/map/map.svg';
import travelBack from '@gouvfr/dsfr/dist/artwork/pictograms/map/travel-back.svg';
import connectionLost from '@gouvfr/dsfr/dist/artwork/pictograms/system/connection-lost.svg';
import error from '@gouvfr/dsfr/dist/artwork/pictograms/system/error.svg';
import flowList from '@gouvfr/dsfr/dist/artwork/pictograms/system/flow-list.svg';
import flowSettings from '@gouvfr/dsfr/dist/artwork/pictograms/system/flow-settings.svg';
import information from '@gouvfr/dsfr/dist/artwork/pictograms/system/information.svg';
import language from '@gouvfr/dsfr/dist/artwork/pictograms/system/language.svg';
import notification from '@gouvfr/dsfr/dist/artwork/pictograms/system/notification.svg';
import padlock from '@gouvfr/dsfr/dist/artwork/pictograms/system/padlock.svg';
import success from '@gouvfr/dsfr/dist/artwork/pictograms/system/success.svg';
import system from '@gouvfr/dsfr/dist/artwork/pictograms/system/system.svg';
import technicalError from '@gouvfr/dsfr/dist/artwork/pictograms/system/technical-error.svg';
import warning from '@gouvfr/dsfr/dist/artwork/pictograms/system/warning.svg';

export const pictograms = {
  accessibility,
  earOff,
  eyeOff,
  mentalDisabilities,
  wheelchair,
  base,
  cityHall,
  companie,
  factory,
  house,
  nuclearPlant,
  school,
  application,
  avatar,
  calendar,
  coding,
  dataVisualization,
  ecosystem,
  inProgress,
  innovation,
  internet,
  mailSend,
  search,
  selfTraining,
  smartphone,
  archive,
  binders,
  conclusion,
  contract,
  documentAdd,
  documentDownload,
  documentSearch,
  documentSignature,
  document,
  drivingLicence,
  drivingLicenseNew,
  internationalDrivingLicenseNew,
  internationalDrivingLicense,
  nationalIdentityCardPassport,
  nationalIdentityCard,
  passport,
  presseCard,
  signDocument,
  taxStamp,
  vehicleRegistration,
  environment,
  food,
  grocery,
  humanCooperation,
  leaf,
  moon,
  mountain,
  sun,
  tree,
  doctor,
  health,
  hospital,
  medicalResearch,
  vaccine,
  virus,
  armyTank,
  astronaut,
  firefighter,
  gendarmerie,
  justice,
  money,
  navyAnchor,
  navyBachi,
  police,
  art,
  audio,
  book,
  catalog,
  community,
  culture,
  digitalArt,
  paint,
  pictures,
  podcast,
  videoGames,
  video,
  airport,
  backpack,
  compass,
  locationFrance,
  locationOverseasFrance,
  luggage,
  mapPin,
  map,
  travelBack,
  connectionLost,
  error,
  flowList,
  flowSettings,
  information,
  language,
  notification,
  padlock,
  success,
  system,
  technicalError,
  warning,
};
